module.exports = __webpack_public_path__ + "static/media/safari-logo.de7711ea.png";